import React, { useState, useEffect } from 'react';
import { Layout, Card, Typography, Row, Col, Statistic } from 'antd';
import { 
  UserOutlined, 
  TeamOutlined
} from '@ant-design/icons';
import axios from 'axios';
import Navigation from '../components/Navigation';
import { useAuth } from '../contexts/AuthContext';

const { Content } = Layout;
const { Title, Text } = Typography;

const Dashboard = () => {
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState({
    totalUsers: 0,
    activeUsers: 0,
    totalClients: 0,
    activeClients: 0
  });
  const { user, isAuthenticated } = useAuth();

  // Загрузка данных дашборда
  useEffect(() => {
    if (isAuthenticated && user) {
      const token = localStorage.getItem('token');
      loadDashboardData(token);
    }
  }, [isAuthenticated, user]);

  const loadDashboardData = async (token) => {
    setLoading(true);
    try {
      // Загружаем статистику
      const statsResponse = await axios.get('https://limitverify.ru:5000/api/dashboard/stats', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStats(statsResponse.data);


    } catch (error) {
      console.error('Error loading dashboard data:', error);
      if (error.response?.status === 401) {
        // Очищаем данные и переходим на логин
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    } finally {
      setLoading(false);
    }
  };

  // Отладочная информация
  console.log('Dashboard render:', { 
    currentUser: user, 
    token: localStorage.getItem('token'), 
    isAuthenticated: !!localStorage.getItem('token'),
    currentUserKeys: user ? Object.keys(user) : null
  });

  if (!user || !localStorage.getItem('token')) {
    console.log('Dashboard: пользователь не авторизован, показываем загрузку');
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh',
          background: '#f0f2f5'
        }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '24px', marginBottom: '16px' }}>Загрузка...</div>
            <div style={{ color: '#666' }}>Пожалуйста, подождите</div>
            <div style={{ marginTop: '16px', fontSize: '12px', color: '#999' }}>
              currentUser: {user ? 'есть' : 'нет'}, token: {localStorage.getItem('token') ? 'есть' : 'нет'}
            </div>
          </div>
        </div>
      </Layout>
    );
  }


  return (
    <Layout style={{ minHeight: '100vh', maxWidth: '100vw', overflow: 'hidden' }}>
      <Navigation />
      
      <Content style={{ padding: '24px', background: '#f0f2f5' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          {/* Приветствие */}
          <div style={{ marginBottom: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <Title level={2}>Добро пожаловать, {user.firstName}!</Title>
              <Text type="secondary">Панель управления системой</Text>
            </div>
          </div>

          {/* Статистика */}
          <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
            <Col xs={24} sm={12} lg={6}>
              <Card>
                <Statistic
                  title="Всего сотрудников"
                  value={stats.totalUsers}
                  prefix={<TeamOutlined />}
                  valueStyle={{ color: '#1890ff' }}
                />
              </Card>
            </Col>
            <Col xs={24} sm={12} lg={6}>
              <Card>
                <Statistic
                  title="Активных сотрудников"
                  value={stats.activeUsers}
                  prefix={<UserOutlined />}
                  valueStyle={{ color: '#52c41a' }}
                />
              </Card>
            </Col>
            <Col xs={24} sm={12} lg={6}>
              <Card>
                <Statistic
                  title="Всего клиентов"
                  value={stats.totalClients}
                  prefix={<UserOutlined />}
                  valueStyle={{ color: '#722ed1' }}
                />
              </Card>
            </Col>
            <Col xs={24} sm={12} lg={6}>
              <Card>
                <Statistic
                  title="Активных клиентов"
                  value={stats.activeClients}
                  prefix={<UserOutlined />}
                  valueStyle={{ color: '#13c2c2' }}
                />
              </Card>
            </Col>
          </Row>

        </div>
      </Content>
    </Layout>
  );
};

export default Dashboard;
